import { AppBar, Box, Divider, Drawer, Skeleton, Toolbar } from '@mui/material';

const AppSkeleton = () => {
  const drawerWidth = 240;

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        width: '100vw',
        bgcolor: 'grey.50',
      }}
    >
      {/* AppBar Skeleton */}
      <AppBar
        position="fixed"
        sx={{
          width: `calc(100% - ${drawerWidth}px)`,
          ml: `${drawerWidth}px`,
          boxShadow: 'none',
          borderBottom: '1px solid',
          borderColor: 'grey.200',
          backgroundColor: 'white',
        }}
      >
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            {/* Placeholder for potential breadcrumbs or title */}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="circular" width={40} height={40} />
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer Skeleton */}
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            borderRight: '1px solid',
            borderColor: 'grey.200',
          },
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
          }}
        >
          <Skeleton
            variant="circular"
            width={40}
            height={40}
            sx={{ mr: 1.5 }}
          />
          <Skeleton variant="text" width="70%" height={30} />
        </Toolbar>
        <Divider />
        <Box sx={{ p: 2 }}>
          {[...Array(6)].map((_, index) => (
            <Box
              key={index}
              sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}
            >
              <Skeleton
                variant="circular"
                width={24}
                height={24}
                sx={{ mr: 2 }}
              />
              <Skeleton variant="text" width="80%" height={20} />
            </Box>
          ))}
        </Box>
      </Drawer>

      {/* Content Skeleton */}
      <Box component="main" sx={{ flexGrow: 1, bgcolor: 'grey.50', p: 3 }}>
        <Toolbar /> {/* Spacer for the AppBar */}
        {/* Page Title Skeleton */}
        <Skeleton variant="text" width="30%" height={48} sx={{ mb: 3 }} />
        {/* Generic Content Skeleton */}
        <Skeleton
          variant="rectangular"
          width="100%"
          height={200}
          sx={{ borderRadius: 2 }}
        />
        <Skeleton
          variant="rectangular"
          width="100%"
          height={300}
          sx={{ mt: 3, borderRadius: 2 }}
        />
      </Box>
    </Box>
  );
};

export default AppSkeleton;
